import { Injectable } from '@angular/core';
import { ResponseData } from '../../nest-responses';
import { NestApiProvider } from '../../nest-api';
import { RequestUpdateSettingOnboarding } from '../dto/setting-onboarding.dto';
@Injectable()
export class SettingOnboardingApi {

  private readonly service: string = '';
  private readonly model: string = 'onBoarding';

  constructor(
    private nestApiProvider: NestApiProvider,
  ) {
  }

  public postOnBoarding(payload: RequestUpdateSettingOnboarding) {
    const method: string = 'POST';
    const func: string = 'postOnBoarding';
    const params: any = payload;
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }

  public getOnBoarding() {
    const method: string = 'GET';
    const func: string = 'getOnBoarding';
    const params: any = {};
    const urlParams: any = {};
    const body: any = {};

    const url = this.nestApiProvider.urlBuilder(method, this.model, func, {}, urlParams, this.service);
    return this.nestApiProvider.request<ResponseData<any>>(method, url, params, urlParams, body);
  }
}



// WEBPACK FOOTER //
// ./src/shared/nestjs/gd-only/services/setting-onboarding.api.ts